import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { IPage, IPageSize, ISearchValue, ISort } from '@interfaces/common/store';

import { defaultMeta } from '../enums/common';

export const setStorePage = (state: WritableDraft<IPage>, action: PayloadAction<IPage>): void => {
	state.page = action.payload.page;
};

export const setStorePageSize = (
	state: WritableDraft<IPageSize & IPage>,
	action: PayloadAction<IPageSize>,
): void => {
	state.pageSize = action.payload.pageSize;
	state.page = defaultMeta.page;
};

export const setStoreSort = (
	state: WritableDraft<ISort>,
	action: PayloadAction<ISort>,
): void => {
	state.sortDirection = action.payload.sortDirection;
	state.sortFieldName = action.payload.sortFieldName;
};

export const setStoreSearchValue = (
	state: WritableDraft<ISearchValue & IPage>,
	action: PayloadAction<ISearchValue>,
): void => {
	state.searchValue = action.payload.searchValue;
	state.page = defaultMeta.page;
};

export const defaultStoreNoSearchDTO = {
	setPage: setStorePage,
	setPageSize: setStorePageSize,
	setSort: setStoreSort,
};

export const defaultStoreDTO = {
	...defaultStoreNoSearchDTO,
	setSearchValue: setStoreSearchValue,
};
